<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Product"
      @click.native.stop
    >
      <v-select
        v-model="productFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="title"
        multiple
        placeholder="Select from list"
        :options="productOptions"
        :clearable="false"
        :reduce="name => name.code"
      />
    </b-form-group>
    <b-form-group
      label="Lot Type"
      @click.native.stop
    >
      <v-select
        v-model="lotTypeFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="title"
        multiple
        placeholder="Select from list"
        :options="lotTypeOptions"
        :clearable="false"
        :reduce="name => name.code"
      />
    </b-form-group>
    <b-form-group
      label="Created At"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option.code"
        v-model="statusFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    vSelect,
    flatPickr,
  },
  props: {
    status: {
      type: [Array, null],
      default: () => [],
    },
    statusOptions: {
      type: [Array, null],
      default: () => [],
    },
    product: {
      type: [Array, null],
      default: () => [],
    },
    productOptions: {
      type: [Array, null],
      default: () => [],
    },
    createdAt: {
      type: [String, null],
      default: null,
    },
    lotType: {
      type: [Array, null],
      default: () => [],
    },
    lotTypeOptions: {
      type: [Array, null],
      default: () => [],
    },
  },
  data() {
    return {
      createdAtFilterValue: this.createdAt,
      statusFilterValue: JSON.parse(JSON.stringify(this.status)) || [],
      productFilterValue: JSON.parse(JSON.stringify(this.product)) || [],
      lotTypeFilterValue: JSON.parse(JSON.stringify(this.lotType)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    createdAt: {
      immediate: true,
      handler(val) {
        this.createdAtFilterValue = val
      },
    },
    status: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    product: {
      immediate: true,
      handler(val) {
        this.productFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    lotType: {
      immediate: true,
      handler(val) {
        this.lotTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('update:status', this.statusFilterValue)
      this.$emit('update:product', this.productFilterValue)
      this.$emit('update:lotType', this.lotTypeFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtFilterValue = ''
      this.statusFilterValue = []
      this.productFilterValue = []
      this.lotTypeFilterValue = []
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('update:status', this.statusFilterValue)
      this.$emit('update:product', this.productFilterValue)
      this.$emit('update:lotType', this.lotTypeFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
